export default __webpack_public_path__ + "static/DevBreak_social-e8e5876bd13af67c5c411d344a039155.png";